
<div  class="title">
  <h1>{{'Safety General Dashboard' | translate | async}}</h1>
</div>

<div class="con">
  <!-- <div class="title">
    <h1>Safety General Dashboard</h1>
  </div> -->
  <div style="text-align: center;margin-top: 20px;" >
    <div style="font-size: 18px;">
      


      
    <mat-form-field >
      <!-- <h4 style=" font-size: 18px;" class="get-label">State</h4> -->
      <mat-select  placeholder="{{'State' | translate | async}}"  (selectionChange)="reloadfields()"  [(ngModel)]="stateID" name="Site" [formControl]="state" required>            
        <mat-option [value]="0">{{"All States" | translate | async}}</mat-option>
        <mat-option *ngFor="let Site of siteCodesList" [value]="Site.Id">
          {{Site.SiteName}} </mat-option>
        </mat-select> 
        <mat-error *ngIf="state.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
 
    
    <mat-form-field class="header-form-full-width invisible"  >
      <mat-select name="name"  class="invisible" >
    </mat-select>
    </mat-form-field>
 
    <mat-form-field >
      <!-- <h4 style=" font-size: 18px;" class="get-label">Month-Year</h4> -->
      <mat-select placeholder="{{'Month-Year' | translate | async}}" (valueChange)="changeValue($event)"  name="month" 
      required [(ngModel)]="inputValueMonth" [value] = "inputValueMonth" [disabled]="state.hasError('required')" >            
        <mat-option *ngFor="let month of monthList" [value]="month.Id">
          {{month.Name}} </mat-option>
        </mat-select>  
    </mat-form-field>
  </div>
   

    
<div *ngIf="isLoading == false" class= "dashboard-header">
  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Checks Completed' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
      <img class="sc-icon" style="height: 60px;
      width: auto;" src ="/api/Application/DealershipLogo/"> 
      
    </div>
    <div class="dashboard">
    <!-- <mat-label>{{Inspections}}({{InspectionQuestions}})</mat-label> -->
    <mat-label> {{'Current Count' | translate | async}} {{Inspections}}</mat-label>
    <div >{{'Target for Month' | translate | async}} {{Target}}</div>
    <div>{{'Target for Date' | translate | async}} {{Expected}}</div>
    <div style ="flex:1;padding: 17px 0px; ">
      <mat-icon *ngIf="isForward90Checkscompleted" class="material-icons sc-icon-unsafe" style="transform: scale(4) rotate(90deg); font-size: 13px; color: green; ">forward</mat-icon>
      <mat-icon *ngIf="isForward270Checkscompleted" class="material-icons sc-icon-unsafe" style="transform: scale(4) rotate(270deg); font-size: 13px; color: green; ">forward</mat-icon>
      <mat-icon *ngIf="isDoneCheckscompleted" class="material-icons sc-icon-safe" style="transform: scale(4); font-size: 13px;color: green; ">done</mat-icon>
    </div>
    </div>
    </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Checks with Fails' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
      <i class="material-icons sc-icon-orange"  style ="transform: scale(3); color:rgb(255, 196, 0);">info</i>
    </div>
    <div class="dashboard">
    <mat-label>{{CheckesWithFails}}/{{TotalChecks}}</mat-label>
    <div>{{checksFailedPct.toFixed()}}%</div>
    </div>
    </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Failed Items' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
      <mat-icon class="material-icons sc-icon-unsafe"  style ="transform: scale(3); color:red;">warning</mat-icon>
    </div>
    <div class="dashboard">
    <mat-label>{{FailedItems}}</mat-label>
    <div>{{failedItemsPct.toFixed()}}%</div>
    </div>
    </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Since Last Fail' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
      <mat-icon class="material-icons sc-icon-safe"  style ="transform: scale(3); color: green;">notification_important</mat-icon>
    </div>
    <div class="dashboard">
    <mat-label>{{DaysSinceLastFail >0 ? DaysSinceLastFail: 'N/A'}}</mat-label>
    <div>{{'Days' | translate | async}}</div>
    </div>
    </div>   
  </div>

</div>
<!-- end header -->

<!-- dashboard body -->
<div *ngIf="isLoading == false" class="dashboard-main">
<div class= "dashboard-header">
  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Incident Counts' | translate | async}}</mat-label>
    <div style= "display: flex;flex-direction: column;">
      <!-- <div class="dashboard" style ="flex:2;margin-top: 18px; text-align: initial;">
        <div>
          <mat-label (click) ="openDialoglastIncidentMTI()" style="cursor: pointer;">{{Label1}}</mat-label> 
          <mat-label  style="cursor: pointer;">Last MTI</mat-label> 

        </div>
        <div>
          <mat-label (click)="openDialoglastIncidentLTI()" style="cursor: pointer;">{{Label2}}</mat-label>
          <mat-label  style="cursor: pointer;">Last LTI</mat-label> 
        </div>
         
    </div> -->
    <!-- <div class="dashboard">
      <mat-label style="cursor: pointer;"> {{ DaysSinceLastIncidentMTIAndAbove >0 ? DaysSinceLastIncidentMTIAndAbove: 'N/A' }}</mat-label>
      <mat-label style="cursor: pointer;"> dd/mm/YYYY</mat-label>

      <p></p>
      <div style="cursor: pointer;">{{ DaysSinceLastLTI >0 ? DaysSinceLastLTI: 'N/A'}}</div>
      <div style="cursor: pointer;">dd/mm/YYYY</div>

    </div> -->


    
      <div style="display: flex;justify-content: space-between;">
        <mat-label  (click) ="openDialoglastIncidentMTI()" style="cursor: pointer;font-size: 18px;">{{Label1}}</mat-label> 
        <mat-label style="cursor: pointer;font-size: 18px;"> {{ DaysSinceLastIncidentMTIAndAbove >0 ? DaysSinceLastIncidentMTIAndAbove: 'N/A' }}</mat-label>
      </div>
      <div  *ngIf="isnoDataMTI==false" style="display: flex;justify-content: space-around;">
        <mat-label  style="cursor: pointer;" (click)="openForm(FormMTI)">{{'Last MTI' | translate | async}}</mat-label> 
        <mat-label style="cursor: pointer;" (click)="openForm(FormMTI)"> {{MTIDate}}</mat-label>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <mat-label (click)="openDialoglastIncidentLTI()" style="cursor: pointer;font-size: 18px;">{{Label2}}</mat-label>
        <mat-label style="cursor: pointer;font-size: 18px;" > {{ DaysSinceLastLTI >0 ? DaysSinceLastLTI: 'N/A' }}</mat-label>
      </div>
      <div *ngIf="isnoDataLTI==false" style="display: flex;justify-content: space-around;">
        <mat-label style="cursor: pointer;" (click)="openForm(FormLTI)">{{'Last LTI' | translate | async}}</mat-label> 
        <mat-label style="cursor: pointer;" (click)="openForm(FormLTI)">{{LTIDate}}</mat-label>
      </div>
    
  </div>
</div>
<div class=dashboard-Pannel>
  <mat-label style="cursor: pointer;" class =dashboard-lable (click) ="openConfigAddMonthlyDashMessageDialog()">{{'Focus Items' | translate | async}}</mat-label>
  <!-- <a mat button  (click) ="openConfigAddMonthlyDashMessageDialog()">Focus Items</a> -->
  <div style= "display: flex;">
    <div style ="flex:1;margin-top: 18px; ">
      <div class="dashboard" style="text-align: center;">
        <mat-label >{{FocusItems}}</mat-label>            
    </div>
  </div>
</div>
</div>
<div class=dashboard-Pannel>
  <mat-label class="dashboard-lable"> {{"Take 5's for Period" | translate | async}}</mat-label>
  <div style= "display: flex;">
    <div class="dashboard" style ="flex:2;margin-top: 18px; text-align: initial;">
        <mat-label>{{'Target' | translate | async}}: {{Take5Target}}</mat-label>  
        <p></p>
        <div>{{'Actual' | translate | async}}: {{Take5Actual}}</div>
    </div>
  <div class="dashboard">
    <mat-label *ngIf="iscurrentActual"> {{currentactual}}</mat-label>
    <div style ="flex:1;margin-top: 18px; ">
      <!-- openConfigAddTakeDialog() TT-6218 -->
      <mat-icon (click)="openConfigAddMonthlyDashMessageDialog()" *ngIf="isForward270" class="material-icons sc-icon-safe"  style ="transform: scale(3) rotate(270deg); color: green; cursor:pointer ; ">forward</mat-icon>
      <mat-icon (click)="openConfigAddMonthlyDashMessageDialog()" *ngIf="isForward90" class="material-icons sc-icon-safe"  style ="transform: scale(3) rotate(90deg);color: green; cursor:pointer ;">forward</mat-icon>
      <mat-icon (click)="openConfigAddMonthlyDashMessageDialog()" *ngIf="isdone" class="material-icons sc-icon-safe" style="transform: scale(3); color: green; cursor:pointer ;" >done</mat-icon>

      
    </div>       
  </div>
</div>
</div>
</div>

<div class= "dashboard-header">
  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Previous 12 Mths Hours' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div class="dashboard" style ="flex:2;margin-top: 18px; text-align: center;">         
          <div>{{Previous12MOntsHours}}</div>
      </div>   
    </div>
  </div>
  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable>{{"Previous 12 Mths TRIFR" | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div class="dashboard" style ="flex:2;margin-top: 18px; text-align: initial;margin-bottom: 5%;">         
          <div>{{'Last 12 Months' | translate | async}} {{Previous12MonthsTRIFR}}</div>
      </div>   
    </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label style="cursor: pointer;" class =dashboard-lable (click) ="openConfigAddMonthlyDashMessageDialog()">{{'Areas of Improvements' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
        <div class="dashboard" style="text-align: center;">
          <mat-label >{{AreasOfImprovement}}</mat-label>            
      </div>
    </div>
  </div>
  </div>

</div>

<div class= "dashboard-header">
  <div class=dashboard-Pannel>
    <mat-label style="cursor: pointer;" class =dashboard-lable (click) ="openConfigAddMonthlyDashMessageDialog()"> {{'Positives' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
        <div class="dashboard" style="text-align: center;">
          <mat-label >{{Positives}}</mat-label>            
      </div>
    </div>
  </div>
  </div>
  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Activities' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
  
        <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"style=" margin: 5px; ">
          <ng-container matColumnDef="Name">
            <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'Name' | translate | async}}</mat-header-cell>
            <mat-cell style="text-align: initial; cursor: pointer;" *matCellDef="let element" (click)="openFormActivitiesComponent(element);"><div class="SerialAndUnitText">{{element.Name}}</div></mat-cell>
          </ng-container>
        
          <ng-container matColumnDef="Total">
            <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'Total' | translate | async}}</mat-header-cell>
            <mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="openFormActivitiesComponent(element);"><div class="SerialAndUnitText">{{element.Total}}</div></mat-cell>
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="displayedColumns"  style="display: none;"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>  
        
    </div>
  </div>
  </div>

  <div class=dashboard-Pannel>
    <mat-label class =dashboard-lable> {{'Incidents' | translate | async}}</mat-label>
    <div style= "display: flex;">
      <div style ="flex:1;margin-top: 18px; ">
        
        <mat-table [dataSource]="dataSource_" matSort class="mat-elevation-z8"style=" margin: 5px; ">
          <ng-container matColumnDef="IncidentName">
            <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'Name' | translate | async}}</mat-header-cell>
            <mat-cell style="text-align: initial; cursor: pointer" *matCellDef="let element" (click)="openFormIncidentsComponent(element);"><div class="SerialAndUnitText">{{element.Name}}</div></mat-cell>
          </ng-container>
        
          <ng-container matColumnDef="IncidentTotal">
            <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'Total' | translate | async}}</mat-header-cell>
            <mat-cell style=" cursor: pointer" *matCellDef="let element" (click)="openFormIncidentsComponent(element);"><div class="SerialAndUnitText">{{element.Total}}</div></mat-cell>
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="displayedColumns_"  style="display: none;"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns_;"></mat-row>
        </mat-table>  
        
    </div>
  </div>
</div>

</div>




</div>


<div *ngIf="isLoading == true" style="width:100%;min-height: 400px;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 400px;">
  <mat-spinner></mat-spinner>
</div>
</div>
</div>